module.exports = __webpack_public_path__ + "img/team-building-dentist.7fbb750f.png";